import React, { Component } from "react";
import { connect } from "react-redux";
import { func, number, string } from "prop-types";
import {
  numOfFrames,
  captureInterval,
  initialCaptureDelay,
  timeout,
} from "../../logic/documentCaptureConfiguration";
import DocumentCaptureUI from "../DocumentCaptureUI";
import TimeoutVisibility from "../TimeoutVisibility";
import NativeCaptureBox from "../NativeCaptureBox";
import PageContent from "../PageContent";
import { Modal } from "react-bootstrap";
import {
  preview,
  retryDocumentQuality,
  changeCamera,
  modalShowed,
} from "../../logic/actions/documentCapture";
import {
  PASSPORT as PASSPORT_AR,
  ID_CARD as ID_CARD_AR,
} from "../../logic/enums/documentAspectRatios";

import { width, height } from "../../logic/documentResolution";
import { WEBRTC, NATIVE } from "../../logic/enums/captureTypes";
import { blobToBase64 } from "../../logic/blobToBase64";
import "./style.css";
import {
  logEvent,
  DOCUMENT_CAPTURE_STARTED,
  DOCUMENT_CAPTURED,
  DOCUMENT_CHANGED_CAMERA,
  DOCUMENT_CAPTURE_NATIVE,
  DOCUMENT_CAPTURE_ERROR,
} from "../../logic/eventLogger";

import { isMobile } from "../../logic/deviceType";
import CaptureButtonPanel from "../CaptureButtonPanel";
import { toggleNetworkWarnings } from "../../logic/actions/apiFetch";
import VisiblityChangeHandler from "../VisiblityChangeHandler";
import { CONNECTION_ISSUES } from "../../logic/enums/errorMessages";

const START = 0;
const CAPTURING = 1;
const PASS = 2;

export class PageDocumentCapturePortrait extends Component {
  static propTypes = {
    preview: func,
    retries: number,
    documentType: string,
    documentQualityHostname: string,
    documentQualityRetries: number,
  };

  constructor(props) {
    super(props);
    this.canvasRef = new React.createRef();

    this.state = {
      pending: true,
      message: "",
      formState: START,
      captureMethod: WEBRTC,
      cameraPermission: true,
      shouldStartNativeCamera: false,
      hideNative: false,
      coords: {},
    };

    this.onCaptureClick.bind(this);
    this.nativeCapture.bind(this);
    this.onDocSDKInitialized.bind(this);
    this.capture.bind(this);
  }

  componentDidMount() {
    if (
      !this.props.base64CroppedFirstPage &&
      this.props.documentType !== "PASSPORT"
    ) {
      this.setState({ hintFacePresent: true });
    }
    this.calculateCoordinates();
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.state.dc.startCamera();
    }
  };

  calculateCoordinates = () => {
    const { clientWidth, clientHeight } = document.querySelector(
      ".ui-canvas-container"
    );

    this.setState({ clientWidth, clientHeight });
    const upperCanvasX = 0.06 * clientWidth;
    const scanningCanvasRegionWidth = clientWidth - 2 * upperCanvasX;
    const scanningCanvasRegionHeight =
      this.props.documentType === "PASSPORT"
        ? scanningCanvasRegionWidth / PASSPORT_AR.aspectRatio
        : scanningCanvasRegionWidth / ID_CARD_AR.aspectRatio;
    const upperCanvasY = clientHeight / 2 - scanningCanvasRegionHeight / 2;
    let coords = {
      ...this.state.coords,
      upperCanvasX,
      upperCanvasY,
      scanningCanvasRegionHeight,
      scanningCanvasRegionWidth,
    };

    this.setState({
      coords: coords,
    });
  };

  captureFeedback(response, calledFrom) {
    if (!response.result && !response.message) {
      this.setState({
        pending: false,
        blobPreview: undefined,
        networkError: true,
        message: CONNECTION_ISSUES,
        formState: START,
      });
    } else {
      if (
        calledFrom !== this.state.captureMethod ||
        this.state.formState === PASS
      )
        return;

      this.setState({
        pending: false,
        blobPreview: undefined,
        networkError: false,
      });

      if (response.result === "PASS") {
        logEvent(DOCUMENT_CAPTURED, {
          value: this.state.documentType,
        });
        logEvent(
          DOCUMENT_CAPTURED + "_" + this.props.documentType.toLowerCase()
        );
        this.state.dc.stopAutoCapture();

        this.setState({
          message: "",
          formState: PASS,
        });

        this.props.preview({
          blob: response.sentBlobImage,
          base64: response.responseBase64Image,
          isRejected: false,
          captureMethod: this.state.captureMethod,
          summaryScorePresent: false,
        });
      } else {
        if (
          !this.props.documentQualityRetriesFront &&
          !this.props.base64CroppedFirstPage
        ) {
          if (
            this.state.dc.bestFrame &&
            this.state.dc.bestFrame.result === "FAIL"
          ) {
            if (this.state.dc.bestFrame.base64Image) {
              this.props.preview({
                blob: this.state.dc.bestFrame.base64Image,
                base64: this.state.dc.bestFrame.base64Image,
                isRejected: true,
                captureMethod: this.state.captureMethod,
                allRetriesFailed: true,
                summaryScorePresent: true,
              });
            } else {
              blobToBase64(this.state.dc.bestFrame.sentBlob).then(
                (base64Image) => {
                  this.props.preview({
                    blob: this.state.dc.bestFrame.sentBlob,
                    base64: base64Image,
                    isRejected: true,
                    captureMethod: this.state.captureMethod,
                    allRetriesFailed: true,
                    summaryScorePresent: true,
                  });
                }
              );
            }
          } else {
            if (this.state.lastFrameCaptured instanceof Blob) {
              blobToBase64(this.state.lastFrameCaptured).then((base64Image) => {
                this.props.preview({
                  isRejected: true,
                  blob: base64Image,
                  base64: base64Image,
                  allRetriesFailed: true,
                  captureMethod: this.state.captureMethod,
                  summaryScorePresent: false,
                });
              });
            } else {
              this.props.preview({
                isRejected: true,
                blob: this.state.lastFrameCaptured,
                base64: this.state.lastFrameCaptured,
                allRetriesFailed: true,
                captureMethod: this.state.captureMethod,
                summaryScorePresent: false,
              });
            }
          }
        } else if (
          !this.props.documentQualityRetriesBack &&
          this.props.base64CroppedFirstPage
        ) {
          if (
            this.state.dc.bestFrame &&
            this.state.dc.bestFrame.result === "FAIL"
          ) {
            if (this.state.dc.bestFrame.base64Image) {
              this.props.preview({
                blob: this.state.dc.bestFrame.base64Image,
                base64: this.state.dc.bestFrame.base64Image,
                isRejected: true,
                captureMethod: this.state.captureMethod,
                allRetriesFailed: true,
                summaryScorePresent: true,
              });
            } else {
              blobToBase64(this.state.dc.bestFrame.sentBlob).then(
                (base64Image) => {
                  this.props.preview({
                    blob: this.state.dc.bestFrame.sentBlob,
                    base64: base64Image,
                    isRejected: true,
                    captureMethod: this.state.captureMethod,
                    allRetriesFailed: true,
                    summaryScorePresent: true,
                  });
                }
              );
            }
          } else {
            if (this.state.lastFrameCaptured instanceof Blob) {
              blobToBase64(this.state.lastFrameCaptured).then((base64Image) => {
                this.props.preview({
                  isRejected: true,
                  blob: base64Image,
                  base64: base64Image,
                  allRetriesFailed: true,
                  captureMethod: this.state.captureMethod,
                  summaryScorePresent: false,
                });
              });
            } else {
              this.props.preview({
                isRejected: true,
                blob: this.state.lastFrameCaptured,
                base64: this.state.lastFrameCaptured,
                allRetriesFailed: true,
                captureMethod: this.state.captureMethod,
                summaryScorePresent: false,
              });
            }
          }
        } else {
          if (this.props.base64CroppedFirstPage) {
            this.props.retryDocumentQuality();
          } else {
            this.props.retryDocumentQuality("front");
          }

          logEvent(DOCUMENT_CAPTURE_ERROR, {
            value: response.feedback || response.message,
          });
          logEvent(
            DOCUMENT_CAPTURE_ERROR + `_${response.feedback || response.message}`
          );

          this.setState({
            message: response.feedback || response.message,
            formState: START,
          });
        }
        if (calledFrom === NATIVE) {
          blobToBase64(response.sentBlobImage).then((base64Image) => {
            this.props.preview({
              blob: base64Image,
              base64: base64Image,
              message:
                response.feedback || !response.message.includes("aborted")
                  ? response.feedback || response.message
                  : CONNECTION_ISSUES,
              isRejected: true,
              captureMethod: this.state.captureMethod,
            });
          });
        }
      }
    }
  }

  captureError(err, calledFrom) {
    console.error(err);
    if (
      calledFrom !== this.state.captureMethod ||
      this.state.formState === PASS
    )
      return;
    this.setState({
      pending: false,
      formState: START,
      blobPreview: undefined,
      message: CONNECTION_ISSUES,
      networkError: true,
    });
  }
  handleShowNativeInstructions = () => {
    this.state.dc.stopCamera();
    this.props.modalShowed();
    this.setState({ nativeInstructions: true });
    if (this.props.count >= 1) {
      this.handleCloseNativeInstructions();
    }
  };

  handleHideNative = () => {
    this.setState({ hideNative: true });
  };

  handleCloseNativeInstructions = () => {
    this.setState({ nativeInstructions: false });
    this.state.shouldStartNativeCamera
      ? this.setState({ shouldStartNativeCamera: false })
      : this.setState({ shouldStartNativeCamera: true });
  };

  capture = () => {
    logEvent(DOCUMENT_CAPTURE_STARTED, {
      value: this.props.documentType,
    });
    logEvent(
      DOCUMENT_CAPTURE_STARTED + "_" + this.props.documentType.toLowerCase()
    );
    const startTime = performance.now();
    this.setState({
      captureMethod: WEBRTC,
      formState: CAPTURING,
      message: "",
      networkError: false,
      startTime,
    });
    const { videoWidth, videoHeight } = this.state.dc.camera.videoEl;
    this.containerRatioX = videoWidth / this.state.clientWidth;
    this.containerRatioY = videoHeight / this.state.clientHeight;
    const upperLeftX = Math.round(
      this.state.coords.upperCanvasX * this.containerRatioX
    );
    const upperLeftY = Math.round(
      this.state.coords.upperCanvasY * this.containerRatioY
    );
    const scanningRegionHeight = Math.round(
      this.state.coords.scanningCanvasRegionHeight * this.containerRatioY
    );
    const scanningRegionWidth = Math.round(
      this.state.coords.scanningCanvasRegionWidth * this.containerRatioX
    );
    const queryParams = {
      upperLeftX,
      upperLeftY,
      width: scanningRegionWidth,
      height: scanningRegionHeight,
    };

    this.props.toggleNetworkWarnings(true);
    this.state.dc
      .captureMultipleFrames({
        croppingTolerance: 0.06,
        hintFacePresent: this.state.hintFacePresent,
        queryParams,
        initialCaptureDelay:
          this.props.initialCaptureDelay || initialCaptureDelay,
        captureInterval: this.props.captureInterval || captureInterval,
        numOfFrames: this.props.numOfFrames
          ? parseInt(this.props.numOfFrames)
          : numOfFrames,
        timeout: this.props.timeout || timeout,
      })
      .then((res) => {
        this.setState({
          lastFrameCaptured: res.sentBlobImage || res.base64Image,
          pending: true,
        });
        return this.captureFeedback(res, WEBRTC);
      })
      .catch((error) => {
        this.captureError(error, WEBRTC);
      })
      .finally(() => this.props.toggleNetworkWarnings(false));
  };

  toggleLoading = () => {
    this.setState({ pending: !this.state.pending });
  };

  tapHandler = () => {
    this.calculateCoordinates();
    this.capture();
    isMobile(navigator.userAgent)
      ? this.setState({ userMessage: "Please keep still" })
      : this.setState({ userMessage: "" });
    setTimeout(() => {
      this.setState({ pending: true, userMessage: "" });
    }, (this.props.captureInterval || captureInterval) * (this.props.numOfFrames || numOfFrames) + parseInt(this.props.initialCaptureDelay || initialCaptureDelay + 50));

    if (
      (!this.props.base64CroppedFirstPage &&
        !this.props.documentQualityRetriesFront &&
        !this.props.blobSecondPage &&
        this.props.documentQualityRetriesBack) ||
      (this.props.base64CroppedFirstPage &&
        !this.props.documentQualityRetriesBack)
    ) {
      setTimeout(() => {
        this.setState({ pending: true, userMessage: "" });
        let video = document.querySelector("video");
        if (video) video.srcObject = undefined;
        this.state.dc.stopCamera();
      }, (this.props.captureInterval || captureInterval) * (this.props.numOfFrames || numOfFrames) + parseInt((this.props.initialCaptureDelay || initialCaptureDelay) + 50));
    }
  };

  nativeCapture = (blob) => {
    logEvent(DOCUMENT_CAPTURE_NATIVE);
    this.setState({ captureMethod: NATIVE, pending: true, formState: START });
    this.props.toggleNetworkWarnings(true);
    this.state.dc
      .assessQuality({
        blob,
        croppingTolerance: 0.06,
        hintFacePresent: this.state.hintFacePresent,
        timeout: this.props.timeout || timeout,
      })
      .then((response) => this.captureFeedback(response, NATIVE))
      .catch((error) => this.captureError(error, NATIVE))
      .finally(() => this.props.toggleNetworkWarnings(false));
  };

  onCaptureClick = () => {
    this.setState({ captureMethod: undefined });
  };

  onDocSDKInitialized = (dc) => {
    this.setState({ dc });
  };

  changeCamera = (cameraId) => {
    logEvent(DOCUMENT_CHANGED_CAMERA);
    this.props.changeCamera(cameraId);
  };

  cameraPermissionDenied = () => {
    this.setState({
      cameraPermission: false,
      message:
        "Please go to browser settings, enable camera permission and then click on button to confirm.",
      isError: true,
      retryCameraInit: false,
      pending: false,
    });
  };

  retryCameraInit = () => {
    this.setState({
      cameraPermission: true,
      retryCameraInit: true,
      message: "",
      isError: false,
      enumerateVideoDevices: true,
      pending: true,
    });
  };

  render() {
    const message =
      this.state.message ||
      "Position your document inside the marked area and click the capture button when you are ready";
    const messageClass = `message-box box-shadow ${
      this.state.networkError ? "message-box-error" : ""
    }`;
    return (
      <PageContent toggleLoading={this.state.pending} type="capture">
        <VisiblityChangeHandler onVisibilityChange={this.onVisibilityChange} />
        <TimeoutVisibility timeout={20000} visible={!this.state.hideNative}>
          <NativeCaptureBox
            onClick={this.onCaptureClick}
            onUploaded={this.nativeCapture}
            changeCamera={this.changeCamera}
            facingMode="environment"
            cameraSelection={true}
            enumerateVideoDevices={this.state.enumerateVideoDevices}
            handleShowNativeInstructions={this.handleShowNativeInstructions}
            shouldStartNativeCamera={this.state.shouldStartNativeCamera}
            handleHideNative={this.handleHideNative}
          />
        </TimeoutVisibility>
        <DocumentCaptureUI
          onInitialized={this.onDocSDKInitialized}
          width={width}
          height={height}
          documentType={this.props.documentType}
          blobPreview={this.state.blobPreview}
          url={
            this.props.documentQualityHostname + "/rest/v1/quality/assessments"
          }
          cameraId={this.props.cameraId}
          captureMethod={this.state.captureMethod}
          cameraPermissionDenied={this.cameraPermissionDenied}
          retryCameraInit={this.state.retryCameraInit}
          toggleLoading={this.toggleLoading}
          clientHeight={this.state.clientHeight}
          clientWidth={this.state.clientWidth}
          coords={this.state.coords}
        />
        <Modal
          show={this.state.nativeInstructions && this.props.count < 2}
          onHide={this.handleCloseNativeInstructions}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <p>
                <strong>
                  Please make sure you can see your document fully, positioned
                  in the center of the screen.
                </strong>
              </p>
            </Modal.Title>
          </Modal.Header>
        </Modal>
        <p className="instructions-on-portrait">{this.state.userMessage}</p>
        <footer>
          <div className={messageClass}>{message}</div>

          {this.state.formState === START && this.state.cameraPermission && (
            <CaptureButtonPanel
              onCaptureClick={this.tapHandler}
              disabled={this.state.formState !== START}
              text="Capture"
            />
          )}
          {!this.state.cameraPermission && (
            <button className={"btn blue"} onClick={this.retryCameraInit}>
              CONFIRM CAMERA PERMISSION
            </button>
          )}
        </footer>
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    const {
      retries,
      documentType,
      base64CroppedFirstPage,
      documentQualityRetriesFront,
      documentQualityRetriesBack,
      cameraId,
      // numOfFrames,
      // initialCaptureDelay,
      // captureInterval,
      width,
      count,
      height,
    } = state.documentCapture;
    const { documentQualityHostname } = state.configuration;
    const {
      numOfFrames,
      initialCaptureDelay,
      captureInterval,
      timeout,
    } = state.configuration.extraConfig.featureFlags;

    const tenant = state.configuration.tenant;

    return {
      retries,
      documentType,
      documentQualityHostname,
      base64CroppedFirstPage,
      documentQualityRetriesFront,
      documentQualityRetriesBack,
      initialCaptureDelay,
      captureInterval,
      numOfFrames,
      cameraId,
      count,
      width,
      height,
      timeout,
      tenant,
    };
  },
  {
    preview,
    retryDocumentQuality,
    changeCamera,
    modalShowed,
    toggleNetworkWarnings,
  }
)(PageDocumentCapturePortrait);
